// extracted by mini-css-extract-plugin
module.exports = {"mainLayoutContent":"Layout_mainLayoutContent__y0rua","loadingLogo":"Layout_loadingLogo__B17Jp"};